import { corporateGroupTableConfigs } from '../../../variables'
import buildMetricValuesHook from '../utils/buildMetricValuesHook'

export const dhWbListLocationGroupDeliveryDataConfigs = {
  ...corporateGroupTableConfigs,
  deliverySumSubtotalDoordash: 'price',
  deliveryTotalOrderCountDoordash: 'number',
  deliverySumErrorChargesDoordash: 'price',
  deliveryOrderWithAnyIssuePercentDoordash: 'percent',
  deliveryAvgCustomerReviewScoreDoordash: 'number',
  deliveryAverageDoordashAvoidableWaitTimeDoordash: 'number',
  deliveryCustomerPositiveRatingCountPercentDoordash: 'percent',
} as const

const useDhWbListLocationGroupDeliveryData = buildMetricValuesHook({
  groupFilterType: 'corporate',
  metrics: {
    codes: [
      'delivery_sum_subtotal_doordash',
      'delivery_total_order_count_doordash',
      'delivery_sum_error_charges_doordash',
      'delivery_order_with_any_issue_percent_doordash',
      'delivery_avg_customer_review_score_doordash',
      'delivery_average_doordash_avoidable_wait_time_doordash',
      'delivery_customer_positive_rating_count_percent_doordash',
    ],
  },
})

export default useDhWbListLocationGroupDeliveryData
